import { Box } from 'components/box';
import { css } from '@emotion/react';
import { Heading } from 'components/typography';
import { useEffect, useRef, useState } from 'react';
import Loading from 'components/loading';
import ErrorBoundary from 'components/_global/error-boundary';
import { trackProductClickEvent } from '../../../../util/tag-manager';
import { CURRENCY_CODE } from '../../../../constants';
import { ProductInterface } from 'types/types';
import Gallery, {
  Layout,
  prepGallerySizes,
} from 'components/_shared/widgets/gallery';

const RELATED_GALLERY_LAYOUT: Layout = [2, 2, 4];

const trackProductClick = (product: ProductInterface) =>
  trackProductClickEvent({
    product: {
      item_name: product.name,
      price: product.price.value,
      item_brand: product.brand,
      currency: CURRENCY_CODE,
    },
  });

const RelatedProductsGallery = ({
  title,
  id,
  products,
}: {
  title: string;
  id: string;
  products?: ProductInterface[];
}) => (
  <Box
    mt={4}
    pt={4}
    id={id}
    css={theme => css`
      grid-area: related;
      border-top: 1px solid ${theme.colors.darkishGrey};
    `}
  >
    <Heading fontSize={[3, 4]} mb="1em">
      {title}
    </Heading>

    {!products && (
      <Loading isLoading size="small">
        <Box
          css={css`
            height: 30px;
          `}
        />
      </Loading>
    )}

    {products && (
      // NOTE: leaving this commented out since we might want it when UNBXD gets implemented
      // <Flex
      //   overflowX={['scroll', 'hidden']}
      //   height="100%"
      //   flexDirection="row"
      //   px={[3, 4]}
      //   m={['-16px -16px 0 -16px', '-16px -32px 0 -32px']}
      //   pt={3}
      //   css={css`
      //     ::-webkit-scrollbar {
      //       display: none;
      //     }
      //   `}
      // >

      //   <Box
      //     /**
      //      * Yes, this looks stupid.
      //      * The last product touches the edge of the screen when scrolling through the products.
      //      * Margins, padding and pseudo-elements were unable to solve this problem, hence this box used
      //      * purely for spacing.
      //      */

      //     className="show-for-mobile-only"
      //     css={css`
      //       min-width: 16px;
      //     `}
      //   />
      // </Flex>
      <Gallery
        items={products}
        layout={prepGallerySizes(products.length, RELATED_GALLERY_LAYOUT)}
        disableProductActions
      />
    )}
  </Box>
);

interface RelatedProductsProps {
  recommendedProducts?: ProductInterface[];
  relatedProducts?: ProductInterface[];
}

const RelatedProducts = ({
  relatedProducts,
  recommendedProducts,
}: RelatedProductsProps) => {
  return (
    <>
      {relatedProducts && relatedProducts.length > 0 && (
        <RelatedProductsGallery
          id="related-products"
          title="Related products"
          products={relatedProducts}
        />
      )}

      {recommendedProducts && recommendedProducts.length > 0 && (
        <RelatedProductsGallery
          id="you-may-also-like"
          title="You may also like"
          products={recommendedProducts}
        />
      )}
    </>
  );
};

const Wrapper = (props: RelatedProductsProps) => {
  // leaving some space here for incoming Netcore integration
  return (
    <ErrorBoundary>
      <RelatedProducts {...props} />
    </ErrorBoundary>
  );
};

export default Wrapper;
